import React, {useState, useEffect} from 'react';
import {getSpuImgList, transImage} from '../../../services';
import {aiimgClickFilterLog, aiimgClickSelectLog} from '../../../log/ubcLog';

const GoodsImgList = props => {
    const {col = 5, setChooseGoodsVisiable, goodsList, sendImgUrl} = props;
    const [allImgs, setAllImgs] = useState([]);
    const [imgs, setImgs] = useState(new Array(col));
    const [loading, setLoading] = useState(false);

    const fetchGoodsImgList = async list => {
        setLoading(true);
        try {
            const res = await getSpuImgList({
                spu_ids: list.map(item => item.num_id || item.originalGoodsId).join(',')
            });

            const {errno, data} = res;
            let tmpArr = [];

            if (errno === 0 && data) {
                data.forEach(item => {
                    tmpArr = tmpArr.concat(item.img_list);
                });
            }

            setLoading(false);
            setAllImgs([...allImgs, ...tmpArr]);
        }
        catch (e) {
            setLoading(false);
        }
    };

    const onSelectImg = url => {
        // setImgUrl(url);
        // setShowCreate && setShowCreate(true);
        sendImgUrl(url);
        aiimgClickSelectLog();
    };

    const convertToTwoDimensionalArray = (arr, n) => {
        let result = [];
        for (let i = 0; i < arr.length; i += n) {
            result.push(arr.slice(i, i + n));
        }
        return result;
    };

    const onClickFilter = () => {
        setChooseGoodsVisiable(true);
        aiimgClickFilterLog();
    };

    useEffect(() => {
        let newImgs = [].concat(imgs);

        allImgs.forEach((item, index) => {
            if (!newImgs[index % col]) {
                newImgs[index % col] = [];
            }
            newImgs[index % col].push(item);
        });

        setImgs(newImgs);
    }, [allImgs]);

    useEffect(() => {
        setLoading(true);
        setImgs([]);
        setAllImgs([]);
        if (goodsList.length) {
            const sliceGoodsList = convertToTwoDimensionalArray(goodsList, 5);

            sliceGoodsList.forEach(item => {
                fetchGoodsImgList(item);
            });
        }
        else {
            setLoading(false);
        }
    }, [goodsList]);

    // 以下渲染相关
    const imgList = imgs.map(list => list.map((item, index) => (
        <div key={item} className="waterfall-item" onClick={() => onSelectImg(item)}>
            <img src={item} />
            <div className="hover-mask">
                <p className="btn">使用该图片</p>
            </div>
        </div>
    )));

    if (!imgList || !imgList[0] || !imgList[0].length) {
        return (
            <div className={`goods-img-list ${col > 2 ? '' : 'small'}`}>
                <div className="row goods-filter">
                    <div className="row">
                        {col > 2 ? <p className="goods-filter-title">选择本店商品图</p> : null}
                        {goodsList.length ? null : <p className="goods-filter-desc">当前展示的是本店所有的商品图</p>}
                    </div>
                    <div
                        className="goods-filter-btn btn-hover"
                        onClick={onClickFilter}
                    >
                        筛选商品
                    </div>
                </div>
                <div className="goods-img-list-empty">
                    {loading
                        ? <img className="goods-img-list-loading-img" src="https://mpics.bdstatic.com/qm/202310/pic_ENExeB_1696663563.gif" />
                        : '暂无可用图片'}
                </div>
            </div>
        );
    }

    return (
        <div className={`goods-img-list ${col > 2 ? '' : 'small'}`}>
            {/* <div className="row goods-filter">
                <div className="row">
                    {col > 2 ? <p className="goods-filter-title">选择本店商品图</p> : null}
                    <p className="goods-filter-desc">当前展示的是本店所有的商品图</p>
                </div>
                <div className="goods-filter-btn" onClick={onClickFilter}>筛选商品</div>
            </div> */}
            <div className="row waterfall">
                <div className="waterfall-row">
                    {imgList[0]}
                </div>
                <div className="waterfall-row">
                    {imgList[1]}
                </div>
                {col > 2 ? (
                    <React.Fragment>
                        <div className="waterfall-row">
                            {imgList[2]}
                        </div>
                        <div className="waterfall-row">
                            {imgList[3]}
                        </div>
                        <div className="waterfall-row">
                            {imgList[4]}
                        </div>
                    </React.Fragment>
                ) : null}

            </div>
        </div>
    );
};

export default GoodsImgList;